module.exports = __webpack_public_path__ + "static/media/bull.e4db9695.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/bull.svg
// module id = 615
// module chunks = 6